module.exports = __webpack_public_path__ + "assets/img/favicon/android-icon-72x72.30efac9d6cd33ef2ef7dead9f36cfb86.png";